import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry/dynamic';

import { type SelectionButtonConfig } from './selection-button.types';

@Component({
  selector: 'app-selection-button',
  templateUrl: './selection-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dynamic],
})
export class SelectionButton {
  readonly config = input.required<SelectionButtonConfig>();
  readonly disabled = input<boolean>();

  readonly action = output<DynamicAction>();

  protected readonly state = computed(() => this.config().state ?? 'idle');

  protected readonly isDisabled = computed(() => this.state() === 'disabled' || this.disabled());

  protected readonly textProps = computed(() => ({
    config: {
      text: this.config().label,
      size: 'base' as const,
      fontWeight: 'semibold' as const,
      color: this.isDisabled() ? 'var(--selectionbutton-disabled-content)' : 'var(--selectionbutton-content)',
      cssVarPrefix: this.isDisabled() ? 'selectionbutton-disabled' : 'selectionbutton',
    },
  }));

  protected onClick(): void {
    if (!this.isDisabled()) {
      const config = this.config();
      const action = config.action ?? { id: 'selectEvent', data: config.value };
      this.action.emit(action);
    }
  }
}
